<template>
  <!-- v-if="$store.state.user.roleId !== 2" -->
  <v-navigation-drawer
    app
    permanent
    v-model="drawerToggle"
    :mini-variant="true"
    :expand-on-hover="false"
    class="main-sidebar"
    mini-variant-width="75"
  >
    <v-list class="pa-0">
      <v-list-tile
        avatar
        :class="['logo-list-item', { 'mini-view': mini }, { 'expanded-view': !mini }]"
      >
        <v-list-tile-avatar class="mt-4">
          <span class="botter-logo-icon white--text sidebar-botter-logo" />
        </v-list-tile-avatar>
        <v-list-tile-content style="width: 300px !important">
          <v-list-tile-title class="sidebar-brandname">
            <router-link to="/" class="white--text">Botter</router-link>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon style="border-radius: 50%; padding: 3px" @click.stop="mini = !mini">
            <v-icon style="height: 30px; width: 30px" class="ma-0" color="white"
              >chevron_left</v-icon
            >
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-list dense class="pt-0 mt-5">
      <template v-for="item in items">
        <v-list-tile
          :key="item.title"
          v-if="readyToMount && item.permission && item.show"
          :to="item.link"
          @click.stop="mini != mini"
          class=""
        >
          <v-list-tile-action>
            <span
              v-if="!item.mdIcon"
              :class="[item.iconClass, 'text-lg-2 white--text']"
              @click="handleQuickAction(item)"
            />
            <v-icon
              v-else
              class="white--text text-lg-2"
              @click="handleQuickAction(item)"
              >{{ item.mdIcon }}</v-icon
            >
          </v-list-tile-action>

          <v-list-tile-content v-if="item.show">
            <v-list-tile-title style="color: #ffffff">{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <v-divider dark />
      <div class="version" hidden>
        <template v-if="version && version.length">
          <div class="version-chip-container">
            <p class="version-main-chip d-block text-center mb-0">V{{ version[0] }}</p>
            <p
              v-if="version.length > 1"
              class="version-inner-chip d-block text-center mb-0"
            >
              {{ version[1] }}
            </p>
          </div>
          <!-- <v-chip v-if="version.length >= 1">
                V{{ version[0] }}
                <span v-if="version.length > 1 && versionTag" class="dist-tag">
                  {{ versionTag[0][0].toUpperCase() }} {{ versionTagNum[1].split('.').join('') }}
                </span>
                 <span v-if="version.length > 1" class="version-inner-chip">
                   {{ version[1] }}
                 </span>
              </v-chip> -->
        </template>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import pack from "@/../package.json";
import common from "../../utils/common";
export default {
  props: {
    drawer: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      pack,
      items: [],
      drawerToggle: true,
      mini: true,
      readyToMount: false,
      settings: {},
    };
  },
  mounted() {
    this.items = [
      {
        title: "Dashboard",
        permission: common.hasPermissions("bot_end_points", ["read"]),
        show: true,
        link: "/",
        iconClass: "botter-home-2-icon",
      },
      {
        title: "Users",
        permission: common.hasPermissions("users", ["read"]),
        show: true,
        link: "/users",
        iconClass: "botter-users-alt-icon",
      },
      {
        title: "Build",
        permission: common.hasPermissions("blocks", ["read", "create", "update"]),
        show: this.botId,
        link: "/build",
        iconClass: "botter-build-2-icon",
      },
      {
        title: "Keywords",
        permission: common.hasPermissions("ai_intents", ["read"]),
        show: this.botId,
        link: "/ai",
        iconClass: "botter-wrap-text-icon",
      },
      // { title: 'Campaign Manager', permission: 1, show:this.botId, link:'/campaigns', iconClass: 'botter-chat-3-icon' },
      {
        title: "NLP",
        link: "/nlp",
        permission: common.hasPermissions("nlp", ["read"]),
        show: this.botId,
        iconClass: "botter-ai-icon",
      },
      {
        title: "LLM",
        link: "/llm/configuration",
        permission: common.hasPermissions("llm", ["read"]),
        show: this.botId,
        iconClass: "botter-chat-3-icon",
      },
      {
        title: "Campaigns",
        permission: common.hasPermissions("campaigns", ["read"]),
        show: this.botId,
        link: "/campaigns/overview",
        iconClass: "botter-chat-3-icon",
      },
      // { title: 'Old NLP', link:'/nlp-legacy', permission: 1, show:this.botId, iconClass: 'memory', mdIcon: true},

      // { title: 'Insights', permission: 1, show:this.botId, link:'/insights', iconClass: 'botter-analytics-icon'},
      {
        title: "Analytics",
        permission: common.hasPermissions("analytics", ["read"]),
        show: this.botId,
        link: "/insights",
        iconClass: "botter-analytics-icon",
      },
      {
        title: "History",
        permission: common.hasPermissions("blocks", ["read"]),
        show: this.botId,
        link: "/chat-history",
        iconClass: "botter-chat-history-icon",
      },
      {
        title: "Settings",
        permission: common.hasPermissions("settings", ["read", "update", "create"]),
        show: this.botId,
        link: "/settings/channel-configuration",
        iconClass: "botter-cogs-2-icon",
      },
      {
        title: "filters",
        permission: common.hasPermissions("settings", ["read"]),
        show: this.botId === "iUQFF0FrCrTj57ZtsJrJ",
        link: "/filters",
        iconClass: "botter-wall-icon",
      },
      {
        title: "Logs",
        permission: common.hasPermissions("activity_logs", ["read"]),
        show: true,
        link: "/activity-logs",
        iconClass: "botter-doc-icon",
      },
      // { title: 'Chat History', permission: 1, show:this.botId, link: '/chat-history', iconClass: 'botter-chat-history-icon'},
    ];
    const vm = this;
    this.$root.$on("route-changed", () => {
      setTimeout(() => {
        vm.mini = true;
      }, 300);
    });
    setTimeout(() => {
      this.readyToMount = true;
    }, 500);
  },
  watch: {
    drawer() {
      // this.drawerToggle = !this.drawerToggle
    },
  },
  computed: {
    botId() {
      return this.$store.state.bot.botId;
    },
    version() {
      return this.pack.version.split("-");
    },
    versionTag() {
      return this.version.length > 1 ? this.version[1].match(/[a-z]*/) : null;
    },
    versionTagNum() {
      return this.version.length > 1 ? this.version[1].split(/[a-z]{1,}/) : null;
    },
  },
  methods: {
    handleQuickAction(item) {
      this.$router.push(item.link);
    },
  },
};
</script>

<style lang="scss">
.main-sidebar {
  overflow-y: auto;
}
.dist-tag {
  position: absolute;
  margin-top: -40px;
  margin-left: 15px;
  z-index: 3;
  background-color: red;
  padding: 3px 5px;
  color: white;
  border-radius: 12px;
  font-size: 10px;
}

.version {
  height: 0;
  .v-list__tile {
    height: 0 !important;
  }
}
.version-chip-container {
  color: white;
  border-radius: 16px;
  font-size: 10px;
  align-items: center;
  width: 100%;
  text-align: center;
  p {
    display: contents;
  }
  .version-main-chip {
    font-size: 12px;
    font-weight: bold;
  }
  .version-inner-chip {
    font-size: 10px;
  }
}
</style>
